import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-[#111111] border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <Logo size={40} />
              <span className="font-['Outfit'] font-semibold text-xl tracking-tight">
                AEO Orchestra <span className="text-[#0055FF]">AI</span>
              </span>
            </Link>
            <p className="text-[#A1A1AA] max-w-md mb-4">{t('footer.tagline')}</p>
            <p className="text-xs text-[#555]">
              {t('footer.company')} <a href="https://solaris-code.com" target="_blank" rel="noopener noreferrer" className="text-[#0055FF] hover:text-[#3377FF]">Solaris Code SL</a> &mdash; {t('footer.location')}
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-['Outfit'] font-semibold mb-4">{t('footer.product')}</h4>
            <ul className="space-y-3 text-[#A1A1AA]">
              <li><a href="/#features" className="hover:text-white transition-colors">{t('footer.features')}</a></li>
              <li><a href="/#pricing" className="hover:text-white transition-colors">{t('footer.pricing')}</a></li>
              <li><Link to="/guide" className="hover:text-white transition-colors">{t('footer.guides')}</Link></li>
              <li><Link to="/changelog" className="hover:text-white transition-colors">{t('footer.changelog')}</Link></li>
              <li><a href="https://www.notion.so/SEO-Orchestra-AI-Documentazione-33df9a7f769d804faba0f60148b5d2c8" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">{t('footer.fullDocs')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-['Outfit'] font-semibold mb-4">{t('footer.companyHeader')}</h4>
            <ul className="space-y-3 text-[#A1A1AA]">
              <li><a href="https://solaris-code.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Solaris Code SL</a></li>
              <li><Link to="/about" className="hover:text-white transition-colors">{t('footer.about')}</Link></li>
              <li><a href="https://wa.me/34694290388" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">{t('footer.contacts')}</a></li>
              <li><Link to="/privacy" className="hover:text-white transition-colors">{t('footer.privacy')}</Link></li>
              <li><Link to="/cookie-policy" className="hover:text-white transition-colors">{t('footer.cookie')}</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors">{t('footer.terms')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#A1A1AA] text-sm">
            &copy; {new Date().getFullYear()} Solaris Code SL &mdash; {t('footer.location')}. {t('footer.rights')}
          </p>
          <a href="https://solaris-code.com" target="_blank" rel="noopener noreferrer" className="text-xs text-[#555] hover:text-[#A1A1AA] transition-colors">
            solaris-code.com
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
